import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import type { MeetingSessionDetails } from "@/api/types"
import { logoutAction } from "@/store/session/logoutAction"

interface MeetingSessionDetailsCacheEntry {
  meetingSessionDetails: MeetingSessionDetails
  lastUpdated: number
}

interface MeetingSessionDetailsState {
  meetingSessionDetails: Record<string, MeetingSessionDetailsCacheEntry>
}

const initialState: MeetingSessionDetailsState = {
  meetingSessionDetails: {},
}

const meetingSessionDetailsSlice = createSlice({
  name: "meetingSessionDetails",
  initialState,
  reducers: {
    setMeetingSessionDetails: {
      reducer(
        state,
        action: PayloadAction<{
          meetingSessionDetails: MeetingSessionDetails
          lastUpdated: number
        }>,
      ) {
        state.meetingSessionDetails[
          action.payload.meetingSessionDetails.sessionId
        ] = action.payload
      },
      prepare(meetingSessionDetails: MeetingSessionDetails) {
        return { payload: { meetingSessionDetails, lastUpdated: Date.now() } }
      },
    },
    removeMeetingSessionDetails(state, action: PayloadAction<string>) {
      delete state.meetingSessionDetails[action.payload]
    },
    clearMeetingSessionDetails(state) {
      state.meetingSessionDetails = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => initialState)
  },
})

export const {
  setMeetingSessionDetails,
  removeMeetingSessionDetails,
  clearMeetingSessionDetails,
} = meetingSessionDetailsSlice.actions
export default meetingSessionDetailsSlice.reducer
